<template>
  <RawHtml :template="template" :is-rte="true" v-bind="$attrs" />
</template>

<script>
import { get } from 'lodash-es'

import RawHtml from '@/js/components/Shared/RawHtml'

export default {
  name: 'BaseRichtext',
  components: {
    RawHtml,
  },
  props: {
    html: {
      type: String,
      default: '',
    },
  },
  computed: {
    template() {
      return (
        this.html ||
        get(this, '$slots.default.0.text', '') ||
        get(this, '$slots.default.0.data.domProps.innerHTML', '')
      )
    },
  },
}
</script>
